<style>
  .ly-print{
    display: inline;
  }
  .ly-print-content{
    display: none;
  }
</style>
<template>
  <div class="ly-print">
    <el-dropdown v-if="multi">
      <el-button size="small" type="primary">
        {{button.group}}<i class="el-icon-caret-bottom el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot='dropdown'>
        <el-dropdown-item v-for="(btn, index) in button" @click="doPrint" :key="index">{{btn.name}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button type="primary" size="small" v-else @click="doPrint">{{button}}</el-button>
    <div class="ly-print-content" ref="content">
        <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    datas: Array,
    multi:String,
    button:[String,Object]
  },
  data () {
    return {

    }
  },
  mounted () {
    if (document.getElementById("lodop1") === null) {
      var oscript = document.createElement("script");
      oscript.src = "http://localhost:8000/CLodopfuncs.js?priority=1";
      oscript.setAttribute("id", "lodop1");
      var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
      head.insertBefore(oscript, head.firstChild);

      oscript = document.createElement("script");
      oscript.src = "http://localhost:18000/CLodopfuncs.js?priority=0";
      oscript.setAttribute("id", "lodop2");
      head.insertBefore(oscript, head.firstChild);
    }
  },
  methods: {
    doPrint () {
      if (typeof getCLodop === "function") {
        this.$emit("print",this.$refs.content)
      } else {
          alert("请安装打印控件！");
      }
    }
  }
}
</script>
